import { Badge, Col, Row } from "reactstrap";
import { BadgeTitle } from "../../../Constants/Constants";
import { DotButtonBadgeData } from "../../../Data/Bonus/Elements";

const DotButtonBadge = () => {
  return (
    <section>
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{BadgeTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {DotButtonBadgeData.map((badge, index) => (
                <div key={index} className={`dot-btn dot-${badge.color} grow font_label`}>
                  <Badge className={`${badge.className} xl`}>{badge.label}</Badge>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default DotButtonBadge;
